import { DeviceSet } from "./DeviceSet";
import { IpSubnetSet } from "./IpSubnetSet";
import { LinkSet } from "./LinkSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";


export class Network implements ObjectSerializer {

	public Devices: DeviceSet;

	public IpSubnets: IpSubnetSet;

	public Links: LinkSet;

	public HistoricalLinks: LinkSet;
		
	constructor() {
		this.Devices = new DeviceSet(this);
		this.IpSubnets = new IpSubnetSet();
		this.Links = new LinkSet();
		this.HistoricalLinks = new LinkSet();
    }

	public static readonly ObjSer_WriteDerivedData = "Network_WriteDerivedData";

	public Write(obj: any, context: any): void {
		let writeDerivedData = false;
		if (context[Network.ObjSer_WriteDerivedData] !== undefined) {
			writeDerivedData = !!context[Network.ObjSer_WriteDerivedData];
		}

		obj.network = {};
		obj = obj.network;

		this.Devices.Write(obj, context);

		if (writeDerivedData) {
			if (this.IpSubnets.Count > 0) {
				this.IpSubnets.Write(obj, context);
			}
			if (this.Links.Count > 0) {
				this.Links.Write(obj, context);
			}
		}

		if (this.HistoricalLinks.Count > 0) {
			context[LinkSet.ObjSer_ObjectName] = "historical_links";
			this.HistoricalLinks.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.network)
			throw new Error();
		obj = obj.network;

		if (obj.devices !== undefined)
			this.Devices.Read(obj, context);

		if (obj.ip_subnets !== undefined)
			this.IpSubnets.Read(obj, context);

		if (obj.links !== undefined)
			this.Links.Read(obj, context);

		if (obj.historical_links !== undefined) {
			context[LinkSet.ObjSer_ObjectName] = "historical_links";
			this.HistoricalLinks.Read(obj, context);
		}

		// Construct references between link-related objects
		this.ResolveLinkReferences();
	}

	// After deserializing links, resolve all unserialized references
	// to devices, links, link members, etc.
	// PRE-CONDITION: The network was just deserialized, and no link-related references already exist
	// POST-CONDITION: All link-related references have been resolved as if RebuildLinks had been called the generate the links
    private ResolveLinkReferences(): void {
        this.Links.ForEach((link) => {
            link.LinkMembers.ForEach((linkMember) => {

				linkMember.ParentLink = link;

				if (linkMember.HasIfKey) {
					var result = linkMember.IfKey.Resolve(this.Devices);
					if (result.Result === true) {
						linkMember.Device = result.Device;
						linkMember.IfEntry = result.IfEntry;

						result.IfEntry.LinkMember = linkMember;
					}
					else {
						console.log("Could not resolve IfKey on LinkMember");
					}
				}
				else if (linkMember.HasDeviceKey) {
					var device = linkMember.DeviceKey.Resolve(this.Devices);
					if (device) {
						linkMember.Device = device;

						device.Links.Add(link);
					}
					else {
						console.log("Could not resolve DeviceKey on LinkMember");
					}
				}
				else {
					console.log("LinkMember contains neither IfKey nor DeviceKey");
				}
            }, this);
        }, this);
    }

	public RebuildIpSubnets():void {
		this.IpSubnets.Rebuild(this.Devices);
	}

}
